import React, { useMemo } from "react";
import { useSelector } from "react-redux";
import { Navigate } from "react-router-dom";
import PropTypes from "prop-types";
import { getPages } from "~/store/selectors/selector.pages";

export const RequireAccess = ({ section, children, redirectTo }) => {
  const initialOrder = useSelector(getPages);

  const accessGranted = useMemo(() => {
    return initialOrder.some((value) => value === section);
  }, [initialOrder, section]);

  return accessGranted ? children : <Navigate to={redirectTo} />;
};

RequireAccess.propTypes = {
  redirectTo: PropTypes.string,
  section: PropTypes.string,
  children: PropTypes.any,
};

RequireAccess.defaultProps = {
  redirectTo: "/not-found",
};
